namespace AgerLMS.Logging {
    export interface LmsNotificationRow {
        Id?: number;
        NotificationType?: NotificationTypes;
        Header?: string;
        Description?: string;
        RelatedUserId?: number;
        RelatedEntityId?: number;
        RelatedEntityType?: EntityTypes;
        IsRead?: boolean;
        RelatedUserDisplayName?: string;
        InsertUserId?: number;
        InsertDate?: string;
        InsertUserDisplayName?: string;
    }

    export namespace LmsNotificationRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Header';
        export const localTextPrefix = 'Logging.LmsNotification';
        export const deletePermission = 'Logging:LmsNotification:Delete';
        export const insertPermission = 'Logging:LmsNotification:Insert';
        export const readPermission = 'Logging:LmsNotification:Read';
        export const updatePermission = 'Logging:LmsNotification:Update';

        export declare const enum Fields {
            Id = "Id",
            NotificationType = "NotificationType",
            Header = "Header",
            Description = "Description",
            RelatedUserId = "RelatedUserId",
            RelatedEntityId = "RelatedEntityId",
            RelatedEntityType = "RelatedEntityType",
            IsRead = "IsRead",
            RelatedUserDisplayName = "RelatedUserDisplayName",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            InsertUserDisplayName = "InsertUserDisplayName"
        }
    }
}
